import Enum from "./Enum";

export default Enum.create( {
	MY_ACTION_ITEMS: "MY_ACTION_ITEMS",
	TEAM_SPACE: "TEAM_SPACE",
	ONE_ON_ONE_SPACE: "ONE_ON_ONE_SPACE",
} );
